/**
 * Hydration (loaded by `src/client.tsx` right after the first paint).
 *
 * Loads the per-document chunks (non-English dictionary + catalog index, the
 * Clerk runtime for signed-in visitors and auth screens) in parallel, then
 * hydrates. English anonymous visitors need no extra chunk.
 */
import { StrictMode, startTransition } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { StartClient } from '@tanstack/react-start/client'
import { prepareClientRuntime } from './lib/runtime/prepare-client'

export async function hydrate(): Promise<void> {
  await prepareClientRuntime()
  startTransition(() => {
    hydrateRoot(
      document,
      <StrictMode>
        <StartClient />
      </StrictMode>,
    )
  })
}
